import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import CategorySection from './components/CategorySection';
import FeaturesSection from './components/FeaturesSection';
import ComparisonSection from './components/ComparisonSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <title>Basetao Spreadsheet Hub - Complete Guides, Templates &amp; Smart Shopping Tools</title>
      <meta name="description" content="Basetao Spreadsheet Hub provides comprehensive guides, free templates, shipping cost calculators, and order tracking tools. Manage your Basetao orders, warehouse data, and optimize costs with expert spreadsheet resources." />
      <meta name="keywords" content="Basetao Spreadsheet, Basetao spreadsheet template, Basetao order tracking, Basetao shipping cost, Basetao warehouse, Basetao review, Basetao coupon, Basetao spreadsheet guide" />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <WhatIsSection />
          <CategorySection />
          <FeaturesSection />
          <ComparisonSection />
          <ArticlesSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}